/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */

import "./ContentTop.css";
import { useContext, useState,useEffect,  } from "react";


import { format } from "date-fns";




import Dropdown from "react-bootstrap/Dropdown";


import { SidebarContext } from "../../../context/SidebarContext";
import { CircleUserRound, LogOut, Menu, PersonStanding } from "lucide-react";









const ContentTop = () => {
  const { toggleSidebar } = useContext(SidebarContext);


const [isNewPopup, setIsNewPopup] = useState(false);
//const [showAlert, setShowAlert] = useState(false);

  //const [isFullscreen, setIsFullscreen] = useState(false);



  const [currentDate, setCurrentDate] = useState(new Date());

 
    useEffect(() => {
      const intervalId = setInterval(() => {
        setCurrentDate(new Date());
      }, 1000); // Update every second
  
      return () => clearInterval(intervalId); // Cleanup the interval on component unmount
    }, []);
  
    const getFormattedTime = (date) => {
      const hours = date.getHours() % 12 || 12; // Convert 0 to 12 for midnight
      const minutes = date.getMinutes();
      const seconds = date.getSeconds();
      const meridiem = date.getHours() >= 12 ? "PM" : "AM";
      return `${hours}:${minutes}:${seconds} ${meridiem}`;
    };
  

  const handleLogOut = () => {
    localStorage.clear();

   history.push("/")
  };

  return (
    <div className="main-content-top" >
      <div className="content-top-left">
        
      

<button
type="button"
className="sidebar-toggler py-1"
onClick={() => toggleSidebar()}
>
<Menu size="25px" />

</button>
        <h4  className="company-name  text-danger  ">
          Smart Mission Techonology Pvt Ltd
        </h4>
     
      </div>
      <div className="content-top-btns d-flex ">
       
        
        
       
      <h5 className="company-name text-danger"> {format(currentDate, "yyyy-MM-dd")} {getFormattedTime(currentDate)}</h5>
        <Dropdown style={{ position: 'relative' }}>
                <Dropdown.Toggle
                
                  as={(props) => (
                    
                      <button {...props}  className="notification-btn-dot content-top-btn "  >
                      <CircleUserRound color="#2ccb2a" /> 
                    </button>
                  )}
                />

                <Dropdown.Menu  style={{ left: 'auto', right: '30px',width:'200px' }} >
                  <div>
                    <div className="px-3">
                 <h4 className="p-0 m-0"> Sign In as</h4>
                    </div>
                    <p className="px-3">{ localStorage.getItem("user")}</p>
                    <hr className="my-0"/>
                    {/* <div type="button" className="btn btn-light d-flex justify-content-start px-2 py-1 w-100" onClick={() => {setIsNewPopup(true)}} >  <RxAvatar size={"30px"} style={{marginRight:'10px'}} /> Change Password</div>

                    <div type="button" className=" btn btn-light d-flex justify-content-start px-2 py-1 w-100"> <CiSettings size={"30px"} style={{marginRight:'10px'}} /> Setting</div> */}
                   
                    <div type="button" className="btn btn-light d-flex justify-content-start px-2 py-1 w-100 flex-end"  onClick={handleLogOut} >  <LogOut size={"30px"} style={{marginRight:'10px'}}/> Log Out</div>
                  </div>
                
                </Dropdown.Menu>
              </Dropdown>
             
                
                
    


       
      
      </div>
    </div>
  );
};

export default ContentTop;
